<!-- 氏名、生まれ年入力スライド -->
<script setup lang="ts">
import { computed } from 'vue';
import type Inquiry from '@/javascripts/utils/inquiry';
import type { InquiryValidation } from '@/javascripts/composables/inquiry/validation';
import { getBirthYears } from '@/javascripts/utils/inquiry_form_options';
/** プロパティ */
const props = defineProps<{
  /** 問い合わせオブジェクト */
  inquiry: Inquiry,
  /** 問い合わせバリデーション */
  v$: InquiryValidation
}>();

/** カスタムイベント */
defineEmits(['next']);

/** 生まれ年の選択肢リスト */
const birthYears = getBirthYears();

/** 名前と生まれ年のバリデーション結果 */
const invalid = computed(() => 
  props.v$.lastName.$invalid ||
  props.v$.firstName.$invalid || 
  props.v$.lastNameKana.$invalid || 
  props.v$.firstNameKana.$invalid || 
  props.v$.birthYearCd.$invalid
);

/** お名前のバリデーションエラー(姓優先) */
const nameValidationErrors = computed(
  () => props.v$.lastName.$error ? props.v$.lastName.$errors : props.v$.firstName.$errors
);

/** ふりがなのバリデーションメッセージ(姓優先) */
const kanaValidationErrors = computed(
  () => props.v$.lastNameKana.$error ? props.v$.lastNameKana.$errors : props.v$.firstNameKana.$errors
);
</script>

<template>
  <div>
    <div class="inquiry-form-post">
      <div class="inquiry-form-item inquiry-form-item-name">
        <div class="inquiry-form-item__heading">
          <p class="inquiry-form-heading">
            <span class="inquiry-form-icon__hissu">必須</span>
            <span>お名前</span>
          </p>
        </div>
        <div class="inquiry-form-item__contact">
          <span>
            <span>
              <input
                type="text"
                class="inquiry-form-textbox"
                placeholder="姓（例：薬剤）"
                v-model="inquiry.lastName">
            </span>
            <span>
              <input
                type="text"
                class="inquiry-form-textbox"
                placeholder="名（例：花子）"
                v-model="inquiry.firstName">
              <p v-for="error in nameValidationErrors" class="inquiry-form-error">
                {{ error.$message }}
              </p>
            </span>
          </span>
        </div>
      </div>
      <div class="inquiry-form-item inquiry-form-item-name-kana">
        <div class="inquiry-form-item__heading">
          <p class="inquiry-form-heading">
            <span class="inquiry-form-icon__hissu">必須</span>
            <span>ふりがな</span>
          </p>
        </div>
        <div class="inquiry-form-item__contact">
          <span>
            <span>
              <input
                type="text"
                class="inquiry-form-textbox"
                placeholder="せい（例：やくざい）"
                v-model="inquiry.lastNameKana">
            </span>
            <span>
              <input
                class="inquiry-form-textbox"
                type="text"
                placeholder="めい（例：はなこ）"
                v-model="inquiry.firstNameKana">
              <p v-for="error in kanaValidationErrors" class="inquiry-form-error">
                {{ error.$message }}
              </p>
            </span>
          </span>
        </div>
      </div>
      <div class="inquiry-form-item inquiry-form-item-age">
        <div class="inquiry-form-item__heading">
          <p class="inquiry-form-heading">
            <span class="inquiry-form-icon__hissu">必須</span>
            <span>生まれ年</span>
          </p>
        </div>
        <div class="inquiry-form-item__contact">
          <span>
            <div class="inquiry-form-select">
              <select
                class="m3p-sp-select m3p-sp-mb15"
                v-model="inquiry.birthYearCd">
                <option disabled value="null">選択してください</option>
                <option
                  v-for="birthYear in birthYears"
                  :key="birthYear.cd"
                  :value="birthYear.cd">
                  {{ birthYear.text }}
                </option>
              </select>
            </div>
          </span>
          <p v-for="error in props.v$.birthYearCd.$errors" class="inquiry-form-error">
            {{ error.$message }}
          </p>
        </div>
      </div>
    </div>
    <div class="form-btnarea">
      <button
        id="gtm_flesh_slide1_next"
        type="button"
        :disabled="invalid"
        class="orange-btn form-btn"
        @click.once="$emit('next')">
        次へ<i class="fa-solid fa-chevron-right"></i>
      </button>
    </div>
  </div>
</template>
